import React, { useEffect, useState } from "react";
import { Card, Form, Button, Col, Row } from "react-bootstrap";
import { handleUpdateCompanySub } from "../API/CompanyApi";
import { toast } from "react-toastify";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";

const CompanyDetails = ({ company, getList }) => {
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [kiosk, setKiosk] = useState(0);
  const [pos, setPos] = useState(0);

  const handleUpdate = async () => {
    if(pos<0 || kiosk < 0){
      return toast.warn('Count cannot be less than 0')
    }
    try {
      const payload = {
        fromDate: moment(moment(fromDate).format('YYYY-MM-DD')).format(
          'YYYY-MM-DDTHH:mm:ss.SSS[Z]',
        ),
        toDate: moment(moment(toDate).format('YYYY-MM-DD')).format(
          'YYYY-MM-DDTHH:mm:ss.SSS[Z]',
        ),
        kiosk: kiosk,
        pos: pos,
        id: company._id,
      };
      const resData = await handleUpdateCompanySub(payload);
      if (resData?.status === "success") {
        toast.success("Subscription updated");
      }
      getList()
    } catch (err) {
      toast.error("Something went wrong");
    }
  };
  useEffect(() => {
    if (company && company?.subDetail) {
      setFromDate(company.subDetail?.pdate);
      setToDate(company.subDetail?.expdate);
      setKiosk(company.subDetail?.kiosk);
      setPos(company.subDetail?.pos);
    }
  }, [company]);

  return (
    <Card>
      <Card.Body>
        <Card.Title className="text-secondary">
          {company?.name}-{company.email}
        </Card.Title>
        <Form>
          <Form>
            <Row className="my-2">
              <Col md={6} lg={6}>
                <Form.Group controlId="formField1">
                  <Form.Label>Admin Name</Form.Label>
                  <Form.Control
                    value={company?.adminDetail?.name}
                    disabled={true}
                    type="text"
                    placeholder="Admin Name"
                  />
                </Form.Group>
              </Col>
              <Col md={6} lg={6}>
                <Form.Group controlId="formField2">
                  <Form.Label>Admin Email</Form.Label>
                  <Form.Control
                    value={company?.adminDetail?.email}
                    disabled={true}
                    type="text"
                    placeholder="Admin Email"
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col md={6} lg={6}>
                <Form.Group controlId="formField1">
                  <Form.Label>Start Date</Form.Label>
                  <DatePicker
                    className="form-control"
                    placeholderText="DD-MM-YYYY"
                    dateFormat="dd-MM-yyyy"
                    selected={fromDate}
                    onChange={setFromDate}
                    minDate={moment()}
                    // Add other props as needed
                  />
                </Form.Group>
              </Col>
              <Col md={6} lg={6}>
                <Form.Group controlId="formField2">
                  <Form.Label>Expiry Date</Form.Label>
                  <DatePicker
                    className="form-control"
                    placeholderText="DD-MM-YYYY"
                    dateFormat="dd-MM-yyyy"
                    selected={toDate}
                    onChange={setToDate}
                    minDate={fromDate}
                    // Add other props as needed
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row className="my-2">
              <Col md={6} lg={6}>
                <Form.Group controlId="formField1">
                  <Form.Label>Kiosk Count</Form.Label>
                  <Form.Control
                    onChange={(e) => setKiosk(e.target.value)}
                    min={0}
                    type="number"
                    placeholder="Kiosk Count"
                  />
                </Form.Group>
              </Col>
              <Col md={6} lg={6}>
                <Form.Group controlId="formField2">
                  <Form.Label>POS Count</Form.Label>
                  <Form.Control
                    onChange={(e) => setPos(e.target.value)}
                    min={0}
                    type="number"
                    placeholder="POS Count"
                  />
                </Form.Group>
              </Col>
            </Row>
          </Form>
          <Row>
            <Col md={6} lg={6} className="m-2">
              <Button variant="primary" onClick={() => handleUpdate()}>
                Submit
              </Button>
            </Col>
          </Row>
        </Form>
      </Card.Body>
    </Card>
  );
};

export default CompanyDetails;
